import { render, staticRenderFns } from "./ResetBtn.vue?vue&type=template&id=62048839&"
import script from "./ResetBtn.vue?vue&type=script&lang=js&"
export * from "./ResetBtn.vue?vue&type=script&lang=js&"
import style0 from "./ResetBtn.vue?vue&type=style&index=0&id=62048839&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports